// extracted by mini-css-extract-plugin
export default {"badge-list":"q1SOS","badgeList":"q1SOS","skeleton-placeholder-pulse":"ljzf2","skeletonPlaceholderPulse":"ljzf2"};